<div class="error-message">
    <!-- <h1>Error</h1> -->
    <p><b>We are unable to log you in at this time</b> - {{errmsg()}}</p>
    <br>
    <br>
    <p *ngIf="this.errorMsg!=='Password Expired' && this.errorMsg!=='Verification Code Expired'">Email <a class="link"  style="font-size: 1em;" href="mailto:ProtectSupport@iconectiv.com">Customer Support</a> for assistance</p>
	<p *ngIf="this.errorMsg==='Password Expired'">You will receive an email containing instructions on how to set a new password.</p>

  </div>
